<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">Notice</li>
      </ol>
    </nav>
    <div>
      <table class="list">
        <colgroup>
          <col width="2">
          <col width="8">
          <col width="8">
          <col width="20">
          <col width="8">
          <col width="8">
        </colgroup>
        <thead>
        <tr>
          <td></td>
          <td>이름</td>
          <td>전화번호</td>
          <td>주소</td>
          <td>선택</td>
          <td>응모일시</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in listData" :key="item.SQ">
          <td>{{ pageResult.listCount - (pageResult.pageNo - 1)*perPage - index }}</td>
          <td class="tc">{{ item.NM }}</td>
          <td class="tc">{{ item.TEL }}</td>
          <td class="tc">{{ item.ADDR }}</td>
          <td class="tc" :title="item.PHRASE" >{{ item.PHONECASE }}</td>
          <td class="tc">{{ item.REG_DTT }}</td>
        </tr>
        <tr v-if="!listData || listData.length === 0">
          <td></td>
          <td colspan="5">등록된 항목이 없습니다</td>
        </tr>
        </tbody>
      </table>
      <div class="tc mt-20">
        <pagination :result="pageResult" @go="changePage"/>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  @import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
  @import '../../less/asset';
  @import '../../less/gynpad';
  @import '../../less/admin';
</style>

<script>
import axios from 'axios';
import handler from '../../util/ErrorHandler';
import Pagination from '../../components/admin/pagination.vue';
import DropFileInput from '../../components/admin/DropFileInput.vue';
import Popup from '../../components/Pop.vue';

export default{
  name: 'News',
  components: { Pagination, DropFileInput, Popup },
  data() {
    return {
      listData: null,
      pageResult: null,
      pageNo: 1,
      perPage: 15,
      detailItem: null,
      edit: false,
    };
  },
  mounted() {
    this.updateList();
  },
  methods: {
    updateList() {
      axios.get('/api/admin/decide', { params: { pageNo: this.pageNo, perPage: this.perPage } })
        .then(({ data }) => {
          if (data.result === 'no-grant') {
            window.location.href = '/admin/login';
            return;
          }
          this.listData = data.list;
          this.pageResult = data.paging;
        })
        .catch(handler());
    },
    changePage(page) {
      this.pageNo = page;
      this.updateList();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/admin/Decide.vue